import { FC, useCallback } from 'react';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { PlayArrow, CheckCircle, Cancel, Pending } from '@mui/icons-material';

import { ContactRequest } from '@libs/models';
import { PostRequestStatus } from '@libs/types';
import { DashboardPageContainer, DataGridV2 as DataGrid } from '@carcareers/components';
import { CONTACT_REQUEST_INDEX_COLUMNS, CONTACT_REQUEST_INDEX_COLUMN_INITIAL_STATE } from '@carcareers/utils';
import { useContactRequestAdminSearchQuery, useContactRequestUpdateStatusMutation } from '@carcareers/store';

export const ContactRequestIndex: FC = () => {
  const search = useContactRequestAdminSearchQuery;
  const [updateStatus] = useContactRequestUpdateStatusMutation();

  const handleUpdateStatus = useCallback(
    (id: number, status: PostRequestStatus) => async () => {
      await updateStatus({ id, status });
    },
    [updateStatus],
  );

  const columns = [
    ...CONTACT_REQUEST_INDEX_COLUMNS,
    {
      field: 'actions',
      type: 'actions' as const,
      align: 'right' as const,
      headerAlign: 'right' as const,
      flex: 1,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          showInMenu
          key={`pending-${params.row.id}`}
          label="Pending"
          icon={<Pending />}
          onClick={handleUpdateStatus(params.row.id, PostRequestStatus.PENDING)}
        />,
        <GridActionsCellItem
          showInMenu
          key={`process-${params.row.id}`}
          label="Process"
          icon={<PlayArrow />}
          onClick={handleUpdateStatus(params.row.id, PostRequestStatus.PROCESSING)}
        />,
        <GridActionsCellItem
          showInMenu
          key={`finish-${params.row.id}`}
          label="Finish"
          icon={<CheckCircle />}
          onClick={handleUpdateStatus(params.row.id, PostRequestStatus.DONE)}
        />,
        <GridActionsCellItem
          showInMenu
          key={`cancel-${params.row.id}`}
          label="Cancel"
          icon={<Cancel color="error" />}
          onClick={handleUpdateStatus(params.row.id, PostRequestStatus.CANCELLED)}
        />,
      ],
    },
  ];

  return (
    <DashboardPageContainer sx={{ pb: 2 }}>
      <DataGrid<ContactRequest>
        query={search}
        columns={columns}
        initialState={{
          columns: {
            columnVisibilityModel: CONTACT_REQUEST_INDEX_COLUMN_INITIAL_STATE,
          },
        }}
      />
    </DashboardPageContainer>
  );
};

export default ContactRequestIndex;
